<div class="max-w-sm animate-pulse {{ numberOfPlaceholders }} overflow-hidden">
    @for (p of randomPercentages; track $index; let first = $first; let last = $last) {
        <div class="h-2 rounded-full bg-gray-200 dark:bg-gray-500" [ngStyle]="{ 'max-width': p + '%' }" [class.mb-2]="!last"></div>
    }
</div>
